/* tslint:disable */
/* eslint-disable */
export enum PaymentTypeEnum {
  Card = 'card',
  Tbi = 'tbi',
  PaymentOrder = 'payment_order'
}
